import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../shared/permission";

let ImportTabsComponent = {
    selector: "vcImportTabs",
    templateUrl: "/angular/components/voter-file/import-tabs.component.html",
    bindings: {
        activeTab: "=?",
    },
    controller: class ImportTabsController {
        // * bindings for typescript compiler *
        public activeTab?: any;
        // ************************************

        public isLeaderView: boolean;
        public isOrgCampaign: boolean;
        public activeCampaign: Campaign;

        private readonly $scope: any;
        private $window: any;

        public navigationBarService: NavigationBarHelperService;
        public permissionProvider: PermissionCheck;

        constructor(
            $scope: any,
            $window: any,
            __app_type: string,
            NavigationBarHelperService: NavigationBarHelperService,
            CampaignDataProvider: CampaignDataProvider,
            PermissionCheck: PermissionCheck
        ) {
            this.$scope = $scope;
            this.$window = $window;

            this.navigationBarService = NavigationBarHelperService;
            this.permissionProvider = PermissionCheck;

            this.isLeaderView = __app_type == "LEADER";
            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
            this.isOrgCampaign =
                __app_type == "USER" &&
                this.activeCampaign.isOrganisationCampaign();
        }

        navigateTo(location: string): void {
            if (this.isLeaderView) {
                this.$window.location = "./leader.php#/leader_" + location;
            } else {
                this.$window.location = "/#/" + location;
            }
        }
    },
};

angular
    .module("voterFile")
    .component(ImportTabsComponent.selector, ImportTabsComponent);
